var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import React, { createContext, memo, useContext, useRef } from 'react';
var selectorPrefix = 'adhere-ui-flex-layout-scroll-layout';
/**
 * ScrollLayoutContext
 */
export var ScrollLayoutContext = /*#__PURE__*/createContext({
  getEl: function () {
    return document.body;
  }
});
/**
 * useScrollLayout
 */
export var useScrollLayout = function () {
  var result = useContext(ScrollLayoutContext);
  return __assign({}, result);
};
/**
 * ScrollLayout
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
var ScrollLayout = /*#__PURE__*/memo(function (props) {
  var children = props.children,
    className = props.className,
    style = props.style,
    scrollY = props.scrollY,
    attrs = __rest(props, ["children", "className", "style", "scrollY"]);
  var wrapRef = useRef(null);
  return /*#__PURE__*/React.createElement(ScrollLayoutContext.Provider, {
    value: {
      getEl: function () {
        return wrapRef === null || wrapRef === void 0 ? void 0 : wrapRef['current'];
      }
    }
  }, /*#__PURE__*/React.createElement("div", __assign({
    ref: wrapRef
  }, attrs, {
    className: classNames(selectorPrefix, className !== null && className !== void 0 ? className : ''),
    style: __assign({
      overflowY: scrollY ? 'auto' : 'hidden'
    }, style !== null && style !== void 0 ? style : {})
  }), children));
});
ScrollLayout.displayName = 'ScrollLayout';
export default ScrollLayout;